import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "ec-287954f7-bbf2-43d6-a1aa-53dba86e44a1-__Layer_1",
  "enable-background": "new 0 0 72 72",
  height: "512",
  viewBox: "0 0 72 72",
  width: "512",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      id: "ec-f7a6e53d-01bc-424f-bd44-db641e438a4a-__Layer_2_1_",
      style: {},
      transform: "matrix(-1, 0, 0, 1, 72, 0)"
    }, [
      _createElementVNode("g", { id: "ec-a6a4387e-a377-455b-83c2-c1e45578be96-__Layer_1-2" }, [
        _createElementVNode("path", {
          id: "ec-42955f48-c530-49c7-a69a-0224630158d1-__format_italic",
          d: "m54 60h-9.6l-10.7-48h8.3c1.7 0 3-1.3 3-3s-1.3-3-3-3h-24c-1.7 0-3 1.3-3 3s1.3 3 3 3h9.6l10.7 48h-8.3c-1.7 0-3 1.3-3 3s1.3 3 3 3h24c1.7 0 3-1.3 3-3s-1.3-3-3-3z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }